import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Checkbox,
  ListItemText,
} from "@mui/material";
import CustomDropdownIcon from "./CustomDropdownIcon";

const CustomSelect = ({
  label,
  options = [],
  value,
  onChange,
  multiple = false,
  minWidth = 160,
  fullWidth,
  color,
fontWeight,
  getOptionLabel = (option) => option?.label || option,
  getOptionValue = (option) => option?.value || option,
  ...props
}) => {
  const isSelected = (optionValue) =>
    multiple ? value?.includes(optionValue) : value === optionValue;

  return (
    <FormControl
      variant="outlined"
      size="small"
      fullWidth={fullWidth}
      sx={{
          minWidth: fullWidth ? "100%" : minWidth,
        fontWeight:fontWeight,
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          "& fieldset": {
            borderColor: "#57257533",
          },
          "&:hover fieldset": {
            borderColor: "#57257533",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#57257533",
          },
          height: 36,
          display: "flex",
          alignItems: "center",
        },
      }}
    >
      <InputLabel
        sx={{
          fontFamily: "Inter",
          fontSize: 14,
          color:
      !value || (Array.isArray(value) && value.length === 0 && color)
        ? color  // grey when nothing is selected
        : "#572575", // purple when selected
       fontWeight: !value || (Array.isArray(value) && value.length === 0 && color)
        ? fontWeight // grey when nothing is selected
        : 600, // purple when selected,
          "&.Mui-focused": {
            color: "#572575",
              fontWeight: 600,
          },
        }}
      >
        {label}
      </InputLabel>
      <Select
        label={label}
        fullWidth={fullWidth}
        multiple={multiple}
        value={value}
        onChange={onChange}
        IconComponent={CustomDropdownIcon}
        renderValue={(selected) => {
          if (multiple) {
            const count = selected?.length || 0;
            return count > 0 ? `Selected (${count})` : "None Selected";
          } else {
            const selectedOption = options.find(
              (option) => getOptionValue(option) === selected
            );
            return selectedOption ? getOptionLabel(selectedOption) : "";
          }
        }}
        sx={{
          fontFamily: "Inter",
          fontSize: 14,
          height: 36,
          display: "flex",
          alignItems: "center",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
            width: fullWidth ? "100%" : minWidth,
          fontWeight:fontWeight,
          "& .MuiSelect-select": {
            paddingTop: "6px",
            paddingBottom: "6px",
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200,
            },
            sx: {
              "& .MuiMenuItem-root": {
                fontFamily: "Inter",
                fontSize: 14,
              },
              "& .Mui-selected": {
                backgroundColor: "#FCE8F8 !important",
                color: "#9D0385 !important",
              },
              "& .Mui-selected:hover": {
                backgroundColor: "#FAD3E3 !important",
              },
            },
          },
        }}
        {...props}
      >
        {options.map((option, index) => {
          const optionValue = getOptionValue(option);
          const optionLabel = getOptionLabel(option);
const isDisabled = option.disabled;
          return (
            <MenuItem key={index} value={optionValue} disabled={isDisabled}>
              {multiple   && !isDisabled ? (
                <>
                  <Checkbox
                    checked={isSelected(optionValue)}
                    sx={{
                      transform: "scale(0.8)", // Shrinks the checkbox
                      color: "#9D0385",
                      "&.Mui-checked": {
                        color: "#9D0385",
                      },
                      padding: "4px", // Less spacing around checkbox
                      marginRight: "4px", // Optional: tighter spacing from label
                    }}
                  />
                  <ListItemText
                    primary={optionLabel}
                    primaryTypographyProps={{
                      fontSize: 13, // or whatever size you want
                      fontFamily: "Inter",
                    }}
                  />
                </>
              ) : (
                optionLabel
              )}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
